import { http, defaultConfig, getUniversityUrl } from './http';

export const fetchInbox = async () => {
  const baseURL = getUniversityUrl();
  const url = '/rest/users/me/messages/inbox';
  return (await http.get<APIResponse<InboxMessageEntity[]>>(url, defaultConfig(baseURL))).data;
};

export const fetchOutbox = async () => {
  const baseURL = getUniversityUrl();
  const url = '/rest/users/me/messages/outbox';
  return (await http.get(url, defaultConfig(baseURL))).data;
};

export const findById = async (id: number | string) => {
  const baseURL = getUniversityUrl();
  const url = `/rest/users/me/messages/${id}`;
  return (await http.get<HttpResponse<InboxMessageEntity>>(url, defaultConfig(baseURL))).data;
};

export const removeById = async (id: number | string) => {
  const baseURL = getUniversityUrl();
  const url = `/rest/users/me/messages/${id}`;
  return (await http.delete(url, defaultConfig(baseURL))).data;
};

export const updateById = async (id: number | string, data: MessageEntity) => {
  const baseURL = getUniversityUrl();
  const url = `/rest/users/me/messages/${id}`;
  return (await http.put(url, data, defaultConfig(baseURL))).data;
};

export const createMessage = async (data: MessageEntity) => {
  const baseURL = getUniversityUrl();
  const url = '/rest/users/me/messages';
  return (await http.post(url, data, defaultConfig(baseURL))).data;
};
